var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

export const encode = (number: number, pad: number) => {
  let value = (number / 64) | 0;
  let curr = number % 64 | 0;

  let encoded = chars.charAt(curr);
  while (value > 0) {
    curr = value % 64 | 0;
    value = (value / 64) | 0;
    encoded = chars.charAt(curr) + encoded;
  }

  return encoded.padStart(pad, "A");
};

export const decode = (encoded: string): number => {
  return encoded
    .split("")
    .map((c) => chars.indexOf(c))
    .reduce((acc, v) => acc * 64 + v, 0);
};

export const varEncode = (number: number) => {
  let value = (number / 32) | 0;
  let curr = number % 32 | 0;

  let encoded = chars.charAt(curr);
  while (value > 0) {
    curr = value % 32 | 0;
    value = (value / 32) | 0;
    encoded = chars.charAt(32 + curr) + encoded;
  }

  return encoded;
};

export const varDecode = (str: string) => {
  let lastChar = chars.indexOf(str[0]);
  let curr = lastChar % 32 | 0;
  let idx = 1;
  while (lastChar >= 32) {
    lastChar = chars.indexOf(str[idx]);
    if (lastChar < 0) {
      break;
    }
    curr = curr * 32 + lastChar;
    idx += 1;
  }
  return curr;
};
export const varDecodeIdx = (str: string, idx: number) => {
  let lastChar = chars.indexOf(str[idx]);
  let curr = lastChar % 32 | 0;
  let currIdx = idx + 1;
  while (lastChar >= 32) {
    lastChar = chars.indexOf(str[currIdx]);
    if (lastChar < 0) {
      break;
    }
    curr = curr * 32 + lastChar;
    currIdx += 1;
  }
  return curr;
};
